import createApiClient from '../api.client';
import { checkYourRate, displayErrors } from '../actions';
import { applicationDataReset } from '../actions/loanApplicationActions';

export default class TimeoutDispatcher {
  constructor(dispatch, apiClient = createApiClient()) {
    this.dispatch = dispatch;
    this.apiClient = apiClient;
  }

  navigateToLandingPage() {
    this.dispatch(checkYourRate());
  }

  applicationDataReset() {
    this.dispatch(applicationDataReset());
  }

  extendSession() {
    return this.apiClient
      .extendSession()
      .catch(errors => {
        this.dispatch(displayErrors(errors));
        return Promise.reject();
      });
  }
}
